module.exports = __webpack_public_path__ + "static/media/profile.23959a0a.svg";